import './Loading.style.scss';
import { CircularProgress } from '@mui/material';

/**
 * Full-page centered loading spinner.
 * Renders a Material-UI `CircularProgress` inside a centered container.
 * Use this as a page-level fallback while async data is being fetched.
 */
export default function Loading(): JSX.Element {
	return (
		<div className="LoadingBox">
			<CircularProgress size={50} />
		</div>
	);
}
